<template>
    <div>
        <head-information
            @rejectcase-click="rejectcase"
            @voidcase-click="voidcase"
            @closecase-click="closecase"
            @backorder-click="passtobackorder"
            @editcase-click="ceeditcase"
            @transferzone-click="transferzone"
            @custcancel-click="custcancel"
            @changeincomplete-click="changeincomplete"
            @changeincompletecomplete-click="changeincompletecomplete"
            @changebackorder-click="changebackorder"
            @returncasetoce-click="returncasetoceconfirm"
            @changecomplete-click="changecomplete"
            @delsub-click="delsub"
            @skipceclosecase-saved="getDetail"
            :status="status"
            :team="team"
            :detailcase="detailcase"
            class="no-pd"
        />
        <!-- <v-card> -->
        <view-caseinformation class="no-pd" :detailcase="detailcase" />
        <view-productinformation class="no-pd" :detailcase="detailcase" />
        <view-customerinformation
            class="no-pd"
            v-if="
                detailcase.main_status_name != 'Closed' ||
                    detailcase.team_name == 'NONHP'
            "
            :detailcase="detailcase"
        />

        <view-engineerformation
            class="no-pd"
            :status="status"
            :detailcase="detailcase"
            :active_tab="0"
        />
        <div v-if="$route.params.team == 'Nonhp'">
            <view-partformation class="no-pd" :detailcase="detailcase" />
        </div>
        <div v-else>
            <view-hpipartformation class="no-pd" :detailcase="detailcase" />
            <view-smsonline
                class="no-pd"
                :detailcase="detailcase"
                :maincase_id="detailcase.maincase_id"
            />
        </div>
        <div v-if="detailcase.project_name == 'ASUS'">
            <view-quote class="no-pd" :maincase_id="detailcase.maincase_id" />
        </div>
        <!-- <view-attachformation :detailcase="detailcase" /> -->
        <view-loginformation
            class="no-pd"
            :status="status"
            :detailcase="detailcase"
        />
        <div v-if="$route.params.team != 'Nonhp'">
            <view-hpcformation class="no-pd" :detailcase="detailcase" />
        </div>

        <!-- <view-performanceformation :detailcase="detailcase" /> -->
        <!-- </v-card> -->
        <v-dialog v-model="dialog" width="1000">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>{{
                    actions.status
                }}</v-card-title>
                <v-card-text>
                    <v-simple-table
                        v-if="
                            actions.status == 'Transfer Zone' &&
                                partsce.length != 0
                        "
                    >
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th
                                        class="text-left"
                                        style="font-weight: bold; color: black"
                                    >
                                        PO / Part_Name / Part_Description
                                    </th>
                                    <th
                                        class="text-left"
                                        style="font-weight: bold; color: black"
                                    >
                                        Key
                                    </th>
                                    <th
                                        class="text-left"
                                        style="font-weight: bold; color: black"
                                    >
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(parts, idx) in partsce" :key="idx">
                                    <td>
                                        {{ parts.ponumber }} /
                                        {{ parts.part_name }} /
                                        {{ parts.part_description }}
                                    </td>
                                    <td>{{ parts.part_issue_id }}</td>
                                    <td>
                                        <v-form
                                            method="post"
                                            id="nativeForm"
                                            v-model="valid1"
                                        >
                                            <v-col
                                                class="d-flex"
                                                cols="12"
                                                sm="6"
                                            >
                                                <v-select
                                                    :label="'statuspart'"
                                                    ref="status_part"
                                                    :rules="selectR"
                                                    :items="statusparts"
                                                    v-model="selectceparts[idx]"
                                                    outlined
                                                ></v-select>
                                            </v-col>
                                        </v-form>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <v-text-field
                        v-model="actions.remark"
                        label="Remark"
                    ></v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" text @click="dialog = false"
                        >Close</v-btn
                    >
                    <v-spacer></v-spacer>

                    <v-btn
                        v-if="
                            actions.status == 'Transfer Zone' &&
                                partsce.length != 0
                        "
                        color="primary"
                        :disabled="!valid1"
                        text
                        @click="saveActions(actions.status)"
                        >Save</v-btn
                    >

                    <v-btn
                        v-else
                        color="primary"
                        text
                        @click="saveActions(actions.status)"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogincomplete" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Change Status
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid">
                        <v-radio-group
                            v-model="change_status.quotation"
                            row
                            :rules="[(v) => !!v || 'Quotation required']"
                        >
                            <v-radio label="เสนอราคา" value="Y"></v-radio>
                            <v-radio label="ไม่เสนอราคา" value="N"></v-radio>
                        </v-radio-group>
                        <v-text-field
                            v-model="change_status.remark"
                            label="Remark"
                            :rules="[(v) => !!v || 'Remark required']"
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="dialogincomplete = false"
                        >Close</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="!valid"
                        color="primary"
                        text
                        @click="saveincomplete()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogcomplete" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Change Status
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="change_status.remark"
                        label="Remark"
                    ></v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="dialogcomplete = false"
                        >Close</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="savecomplete()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-row justify="center">
            <v-dialog
                v-model="dialogincompletecomplete"
                persistent
                max-width="600px"
            >
                <v-card>
                    <v-form method="post" id="nativeForm" v-model="valid2">
                        <v-card-title>
                            <span class="headline">Update Status Case.</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-select
                                            dense
                                            outlined
                                            :items="['Complete', 'Incomplete']"
                                            label="Status"
                                            required
                                            v-model="form.status"
                                            :rules="statusR"
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        class="mar-t-20 mb-1"
                                        v-if="form.status === 'Complete'"
                                    >
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                class="text-center"
                                            >
                                                ลูกค้าพึงพอใจกับการบริการครั้งนี้หรือไม่
                                            </v-col>

                                            <v-col
                                                cols="12"
                                                class="text-center mar-t-20"
                                            >
                                                <img
                                                    :class="
                                                        form.customer_level ===
                                                        'L'
                                                            ? 'fix-png-a clik-cor red '
                                                            : 'fix-png-a'
                                                    "
                                                    src="../../../assets/all/sad.png"
                                                    @click="cick_cus('L')"
                                                />

                                                <img
                                                    class=""
                                                    :class="
                                                        form.customer_level ===
                                                        'M'
                                                            ? 'fix-png-a ml-2 mr-2 clik-cor yellow '
                                                            : 'fix-png-a ml-2 mr-2'
                                                    "
                                                    src="../../../assets/all/face.png"
                                                    @click="cick_cus('M')"
                                                />

                                                <img
                                                    :class="
                                                        form.customer_level ===
                                                        'H'
                                                            ? 'fix-png-a clik-cor teal accent-3'
                                                            : 'fix-png-a'
                                                    "
                                                    src="../../../assets/all/smile.png"
                                                    @click="cick_cus('H')"
                                                />
                                            </v-col>

                                            <v-col
                                                cols="12"
                                                class="text-center mar-t-20"
                                                v-if="
                                                    chk_customer_level === true
                                                "
                                            >
                                                <span
                                                    class="text-color-red font-fix-13"
                                                    >** Customer level is
                                                    required</span
                                                >
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                v-if="
                                                    detailcase.project_name ===
                                                        'CDAX' &&
                                                        detailcase.product_group ==
                                                            'Computing'
                                                "
                                            >
                                                <v-radio-group
                                                    v-model="form.uefi"
                                                    :rules="uefiR"
                                                    required
                                                    row
                                                >
                                                    <v-radio
                                                        label="มี UEFI"
                                                        value="Y"
                                                    ></v-radio>
                                                    <v-radio
                                                        label="ไม่มี UEFI"
                                                        value="N"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>

                                            <v-col cols="12" class="mar-t-10">
                                                <v-combobox
                                                    v-if="form.uefi === 'N'"
                                                    :items="[
                                                        'PND - Part detected โดยระบบไม่ได้ เช่น No Power',
                                                        'DHU - โปรแกรม diagnostic ค้าง หรือ ไม่สำเร็จ',
                                                        'PPR - พาร์ทที่เทส UEFI ผ่านแต่ยังต้องเปลี่ยนแปลง HDD เรื่องจากยังมีอาการอยู่',
                                                        'CNR - ลูกค้าไม่สะดวกให้เทส',
                                                    ]"
                                                    dense
                                                    outlined
                                                    label="ระบุ UEFI"
                                                    v-model="form.uefi_text"
                                                    :rules="uefi_textRR"
                                                ></v-combobox>
                                                <v-text-field
                                                    outlined
                                                    v-if="form.uefi === 'Y'"
                                                    dense
                                                    label="ระบุ UEFI"
                                                    v-model="form.uefi_text"
                                                    :maxlength="27"
                                                    :counter="27"
                                                    @keyup="checkfid_text()"
                                                    :rules="uefi_textR"
                                                    required
                                                ></v-text-field>

                                                <v-progress-linear
                                                    v-if="load === true"
                                                    indeterminate
                                                    color="cyan"
                                                ></v-progress-linear>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row>
                                            <v-col
                                                cols="12"
                                                class="text-center"
                                                v-if="
                                                    detailcase.project_name ===
                                                        'CDAX' &&
                                                        form.status ===
                                                            'Incomplete'
                                                "
                                            >
                                                <v-radio-group
                                                    v-model="form.quotation"
                                                    :rules="quotationR"
                                                    required
                                                    row
                                                >
                                                    <v-radio
                                                        label="เสนอราคา"
                                                        value="Y"
                                                    ></v-radio>
                                                    <v-radio
                                                        label="ไม่เสนอราคา"
                                                        value="N"
                                                    ></v-radio>
                                                </v-radio-group>
                                            </v-col>

                                            <v-col
                                                class="mar-t-10"
                                                cols="12"
                                                v-if="form.status != null"
                                            >
                                                <div
                                                    v-if="
                                                        form.status ===
                                                            'Complete'
                                                    "
                                                >
                                                    <v-combobox
                                                        :items="data_symptom"
                                                        v-model="
                                                            form.ce_symptom
                                                        "
                                                        label="อาการเสียที่พบ (ภาษาอังกฤษ)"
                                                        :rules="ce_symptomR"
                                                        dense
                                                        outlined
                                                    ></v-combobox>
                                                </div>
                                                <div>
                                                    <v-textarea
                                                        outlined
                                                        label="Solution"
                                                        v-model="form.solution"
                                                        :rules="
                                                            engineer_statusR2
                                                        "
                                                    ></v-textarea>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="dialogincompletecomplete = false"
                                >Close</v-btn
                            >

                            <v-btn
                                color="success"
                                @click="save_case()"
                                :disabled="!valid2"
                                >Save</v-btn
                            >
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-row>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios"

import { mapState, mapMutations } from "vuex"

import HeadInformation from "./HeadInformation"
import ViewCaseInformation from "./ViewCaseInformation"
import ViewProductInformation from "./ViewProductInformation"
import ViewCustomerInformation from "./ViewCustomerInformation"
import ViewEngineerInformation from "./ViewEngineerInformation"
import ViewPartInformation from "./ViewPartInformation"
import ViewHpiPartInformation from "./ViewHpiPartInformation"
import SmsOnline from "./SmsOnline.vue"

import ViewLogInformation from "./ViewLogInformation"
import ViewAttachInformation from "./ViewAttachInformation"
import ViewHpcInformation from "./ViewHpcInformation"
import ViewPerformanceInformation from "./ViewPerformanceInformation"
import Quote from "./Quote"
let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    components: {
        "head-information": HeadInformation,
        "view-caseinformation": ViewCaseInformation,
        "view-customerinformation": ViewCustomerInformation,
        "view-productinformation": ViewProductInformation,
        "view-loginformation": ViewLogInformation,
        "view-attachformation": ViewAttachInformation,
        "view-partformation": ViewPartInformation,
        "view-hpipartformation": ViewHpiPartInformation,
        "view-engineerformation": ViewEngineerInformation,
        "view-hpcformation": ViewHpcInformation,
        "view-performanceformation": ViewPerformanceInformation,
        "view-quote": Quote,
        "view-smsonline": SmsOnline,
    },
    watch: {
        "$route.params.caseid": function(val) {
            this.getDetail()
        },
    },
    beforeMount() {
        this.getDetail()
    },
    data() {
        return {
            quotationR: [(v) => !!v || "quotation Status is required"],
            load: false,
            uefiR: [(v) => !!v || "UEFI Status is required"],
            dialog_loading: false,
            data_symptom: [],
            uefi_textR: [
                (v) => !!v || "UEFI Text is required",
                (v) =>
                    v.length === 27 || "UEFI must be less than 27 characters",
            ],
            uefi_textRR: [(v) => !!v || "UEFI Remark  is required"],
            ce_symptomR: [(v) => !!v || "โปรดระบุอาการเสียที่พบ (ภาษาอังกฤษ)"],
            chk_customer_level: false,
            form: {
                maincase_id: 0,
                status: null,
                customer_level: "",
                uefi: "",
                uefi_text: "",
                ce_symptom: "",
                solution: "",
            },
            statusR2: [(v) => !!v || "Status is required"],
            statusR: [(v) => !!v || "Engineer Status is required"],
            engineer_statusR2: [(v) => !!v || "Engineer Status is required"],
            engineer_statusR: [(v) => !!v || "Engineer Status is required"],
            valid2: false,
            valid1: false,
            selectR: [(v) => !!v || "SelectStatusPart is required"],
            statusparts: ["Good", "Bad", "DOA", "Cancel"],
            team_name: localStorage.team_name,
            closeOnClick: false,
            detailcase: [],
            partsce: [],
            selectceparts: [],
            actions: {
                status: "",
                remark: "",
            },
            status: this.$route.params.status,
            team: this.$route.params.team,
            dialog: false,
            dialogincomplete: false,

            dialogcomplete: false,
            dialogincompletecomplete: false,
            change_status: {
                quotation: "",
                remark: "",
            },
            valid: false,
        }
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),

        ...mapMutations(["mutateIsLoading"]),
        async save_case() {
            if (this.form.status == "Incomplete") {
                this.form.ce_symptom = ""
                this.form.customer_level = ""
                this.form.uefi = ""
                this.form.uefi_text = ""
            } else {
                this.form.quotation = ""
            }
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            await axios
                .post(
                    url + "engineer/waiting-customer-admin",
                    this.form,
                    options
                )
                .then((response) => {
                    this.form = {
                        maincase_id: 0,
                        status: null,
                        customer_level: "",
                        ueft: "",
                        uefi_text: "",
                        ce_symptom: "",
                        solution: "",
                    }
                    this.dialogincompletecomplete = false
                    this.dialog_loading = false
                    this.getDetail()

                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async search_symptom(c) {
            let send = {
                maincase_id: c,
            }
            this.form.maincase_id = c
            this.dialog_loading = true
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            await axios
                .post(url + "engineer/search-symptom", send, options)
                .then((response) => {
                    this.dialog_loading = false
                    this.data_symptom = response.data
                    this.dialogincompletecomplete = true
                    // console.log(response, "search-symptom");
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        cick_cus(c) {
            this.form.customer_level = c
        },
        returncasetoceconfirm(c) {
            this.$swal({
                title: "Confirm Return Case " + c + " To CE ?",
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    this.returncasetoce()
                } else {
                    // console.log("--no")
                }
            })
        },
        async returncasetoce() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/it/task/save-return-case`
            var sent = {
                date: this.detailcase.subs[this.detailcase.subs.length - 1]
                    .onsite_at,
                engineer: this.detailcase.subs[this.detailcase.subs.length - 1]
                    .engineer,
                subcase_id: this.detailcase.subs[
                    this.detailcase.subs.length - 1
                ].subcase_id,
            }
            try {
                const { data } = await axios.post(url, sent, options)
                this.getDetail()
                this.dialog = false
            } catch (error) {
                console.log(error)
            }
        },
        async saveActions(params) {
            alert(params)
            const url =
                params == "Reject Case"
                    ? `${process.env.VUE_APP_ROOT_API}/api/rejected-case/${this.$route.params.caseid}`
                    : params == "Void Case"
                    ? `${process.env.VUE_APP_ROOT_API}/api/void-case/${this.$route.params.caseid}`
                    : params == "Delete Last Sub"
                    ? `${process.env.VUE_APP_ROOT_API}/api/delete-last-sub/${this.$route.params.caseid}`
                    : params == "Cust. Cancel"
                    ? `${process.env.VUE_APP_ROOT_API}/api/engineer/updatecase`
                    : params == "Transfer Zone"
                    ? `${process.env.VUE_APP_ROOT_API}/api/transfer-zone`
                    : `${process.env.VUE_APP_ROOT_API}/api/return-to-backorder/${this.$route.params.caseid} `

            if (
                params == "Void Case" &&
                this.detailcase.sms_status == "Y" &&
                this.detailcase.sms_language != null
            ) {
                let str
                if (this.detailcase.sms_language == "th") {
                    str = `งานซ่อมหมายเลข ${this.detailcase.case_id} ได้รับการยกเลิกแล้ว สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                } else if (this.detailcase.sms_language == "en") {
                    str = `Case no: ${this.detailcase.case_id} has been cancelled. For more information, please call 020781589.`
                }
                let str_th = str
                str = str
                    .split("")
                    .map((char) => addZeros(char.charCodeAt(0).toString(16)))
                    .join("")
                // console.log(str)
                function addZeros(str) {
                    return ("0000" + str).slice(-4)
                }

                this.detailcase.str = str
                this.detailcase.str_th = str_th
            }
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            if (params == "Transfer Zone" && this.partsce.length != 0) {
                for (let i = 0; i < this.partsce.length; i++) {
                    if (this.selectceparts[i] == undefined) {
                        this.$swal(
                            "กรุณาเลือกสถานะ Parts " + i + "ด้วยครับ",
                            "Select Status Parts" + i,
                            "info"
                        )

                        this.$refs.status_part[i].focus()
                        exit()
                    } else {
                        this.partsce[i].status = this.selectceparts[i]
                    }
                }

                this.partsce1 = []
                this.partsce.map((each) => {
                    var sent = {
                        part_issue_id: each.part_issue_id,
                        status: each.status,
                    }
                    this.partsce1.push(sent)
                })

                var body = {
                    maincase_id: this.detailcase.maincase_id,
                    parts: this.partsce1,
                    remark: this.actions.remark,
                }
            } else if (params == "Transfer Zone" && this.partsce.length == 0) {
                var body = {
                    maincase_id: this.detailcase.maincase_id,
                    remark: this.actions.remark,
                }
            } else if (params == "Cust. Cancel") {
                var body = {
                    date: "",
                    remark: this.detailcase.remark,
                    status: 4,
                    maincase_id: this.detailcase.maincase_id,
                    subcase: this.detailcase.subcase_id,
                }
            } else {
                var body = {
                    remark: this.actions.remark,
                    str: this.detailcase.str,
                    str_th: this.detailcase.str_th,
                    sms_language: this.detailcase.sms_language,
                    sms_status: this.detailcase.sms_status,
                    customer_tel: this.detailcase.customer_tel,
                    project_name: this.detailcase.project_name,
                    maincase_id: this.detailcase.maincase_id,
                    subcase_id: this.detailcase.subcase_id,
                }
            }
            console.log(body, "-body")
            try {
                const { data } = await axios.post(`${url}`, body, options)
                if (data != "") {
                    this.getDetail()
                    this.dialog = false
                }
            } catch (error) {
                console.log(error)
            }
        },
        async closecase() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/closed-case/${this.detailcase.maincase_id}`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const { data } = await axios.post(`${url}`, [], options)
            this.getDetail()
        },
        delsub() {
            this.actions.status = "Delete Last Sub"
            this.dialog = true
        },
        async custcancel() {
            this.actions.status = "Cust. Cancel"
            this.dialog = true
        },
        transferzone() {
            this.partsce = []
            this.selectceparts = []

            for (let i = 0; i < this.detailcase.parts.length; i++) {
                if (this.detailcase.parts[i].ce_status == null) {
                    this.partsce.push({
                        part_issue_id: this.detailcase.parts[i].part_issue_id,
                        part_name: this.detailcase.parts[i].part_name,
                        part_description: this.detailcase.parts[i]
                            .part_description,
                        ponumber: this.detailcase.parts[i].ponumber,
                    })
                }
            }
            // console.log(this.partsce, this.detailcase, "gg");
            this.actions.status = "Transfer Zone"
            this.dialog = true
        },
        voidcase() {
            this.actions.status = "Void Case"
            this.dialog = true
        },
        rejectcase() {
            this.actions.status = "Reject Case"
            this.dialog = true
        },
        passtobackorder() {
            this.actions.status = "Return BackOrder"
            this.dialog = true
        },
        async getDetail() {
            this.dialog_loading = true
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/casedetail/${this.$route.params.caseid}`
            try {
                const { data } = await axios.get(`${url}`, options)
                this.detailcase = data
                this.dialog_loading = false
                console.log(this.detailcase, "-main xx cases")
            } catch (error) {
                console.log(error)
                this.dialog_loading = false
            }
        },
        ceeditcase() {},
        changeincompletecomplete() {
            this.search_symptom(this.detailcase.maincase_id)
        },
        changebackorder() {
            this.$swal({
                title: `Are you change to backorder?`,
                icon: "warning",
                buttons: true,
                inputPlaceholder: "Reason",
                showCancelButton: true,
                closeOnConfirm: false,
            }).then((result) => {
                if (result !== null) {
                    this.dialog_loading = true
                    const options = {
                        headers: {
                            Authorization: "Bearer " + localStorage.token,
                        },
                    }
                    let dataPh = {
                        maincase_id: this.detailcase.maincase_id,
                        subcase_id: this.detailcase.subcase_id,
                    }
                    axios
                        .post(
                            `${process.env.VUE_APP_ROOT_API}/api/change-to-backorder/`,
                            dataPh,
                            options
                        )
                        .then((response) => {
                            // console.log(response)
                            this.dialog_loading = false
                            this.getDetail()
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        changeincomplete() {
            this.change_status.quotation =
                this.detailcase.warranty_type == "OOW" ? "Y" : ""
            this.dialogincomplete = true
            this.$refs.form.validate()
        },
        async saveincomplete() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/change-to-incomplete/${this.detailcase.maincase_id}`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            this.mutateIsLoading()
            const { data } = await axios.post(
                `${url}`,
                this.change_status,
                options
            )
            this.dialogincomplete = false
            this.getDetail()
            this.mutateIsLoading()
        },
        changecomplete() {
            this.dialogcomplete = true
        },
        async savecomplete() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/change-to-complete/${this.detailcase.maincase_id}`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            this.mutateIsLoading()
            const { data } = await axios.post(
                `${url}`,
                this.change_status,
                options
            )
            this.dialogcomplete = false
            this.getDetail()
            this.mutateIsLoading()
        },
    },
}
</script>
<style scoped>
.image-cso {
    height: 100px;
    cursor: pointer;
    margin: 5px;
    display: inline-block;
}
.image-cso-btn {
    margin-top: -10px !important;
    margin-left: -18px !important;
}
.fix-png-a {
    width: 35px;
    height: 35px;
    cursor: pointer;
    border-radius: 20px;
}
.v-alert {
    display: block;
    font-size: 16px;
    margin-bottom: 0px;
    padding: 10px;
    position: relative;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
